import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet, ViewProps } from 'react-native'

export const Body: FunctionComponent<ViewProps> = ({ style, ...props }) => <View style={[styles.content, style]} {...props} />

const styles = StyleSheet.create({
  content: {
    flex: 1,
    flexDirection: 'row',
  },
})
